import db from "@/components/firebaseInit";
import firebase from 'firebase';
import store from "../store";
import axios from "axios";
export default {

	SubscribeUser: async function (
		eventcollectionname: string,
		UserEmail: string,
		attendeeID: string,
		flg: boolean
	) {
		var IsSubscribed = false;
		const messaging = firebase.messaging();
		//new code-------------------------------------------------

		if (location.host.toLowerCase().indexOf("localhost") >= 0) {
			messaging.usePublicVapidKey('BPT6YJxUdXuCW1ftEXYKNGt0xsBjZkF2_BeRC4_mvT2qvy9uOKs0EOFjo4gEwZe8tHriaX-ulH42MyzWFpSNrbU');//uat key
		} else if (location.host.toLowerCase().indexOf("uat") >= 0) {
			messaging.usePublicVapidKey('BPT6YJxUdXuCW1ftEXYKNGt0xsBjZkF2_BeRC4_mvT2qvy9uOKs0EOFjo4gEwZe8tHriaX-ulH42MyzWFpSNrbU');//uat key
		} else if (location.host.toLowerCase().indexOf("stage") >= 0) {
			messaging.usePublicVapidKey('BFHfwpzkBEqC3noLT0XrhSb2__sHW2hxq5_bhLjtxZ71E1o6vb6AoRn9T-z_uB8WpkCnF0u4DRjDtRQIqwevFEU');//stage key
		}
		else {
			messaging.usePublicVapidKey('BFEKcFgM3PBjPHNx6ZEI8puvpioqJmSeaKmzffhtgLtbF8Gyn_sD7jW7leOzdTLGNYek26iZ9ogUieK6u9_t_Mg');//PRD key
		}
		messaging.getToken().then((currentToken) => {
			let docObjdevce = new Object({ DeviceToken: currentToken, DeviceType: "Web", userAgent: navigator.userAgent, IsOptIn: true });
			store.commit("AddloggedInDeviceToken", "");
			store.commit(
				"AddloggedInDeviceToken",
				currentToken
			);
			console.log("token:" + currentToken);
			var NotificationListId = attendeeID;
			debugger;
			var docRef = db
				.collection(eventcollectionname)
				.doc("SubscribersList")
				.collection("Subscriptions")
				.doc(NotificationListId);
			docRef
				.get()
				.then(function (doc) {
					if (!doc.exists) {
						var docObj = {
							AttendeeID: attendeeID,
							Email: UserEmail,
							Devices: [docObjdevce],
							CreatedDate: new Date(),
							LastModifiedDate: new Date()
						};
						if (flg === true) {
							if (confirm("Do you want to subscribe for web push notifications?")) {
								docRef
									.set(docObj)
									.then(function () {
										IsSubscribed = true;
										store.commit("GetPopupNotification", IsSubscribed);
										console.log("NotificationList Created : " + NotificationListId);
										debugger;
										//---------------------- FCM subscribe---------------------------------------------------
										var xAPIkey = "AAAAG8IFqjo:APA91bFOKr3FfPU-5AvL7MT3iKTVoibWIiCKGGRW03nXEmfqbyKfdgN_13R9sTV44JgXWsAN-tR4YGN-6UNcPn04otBHPoeC6ST3mf57aouf9BAjKlwv-X79cs4QTBEW7jbCbo1hqV4W";
										console.log("currentToken:- " + currentToken);
										var apiUrl = 'https://iid.googleapis.com/iid/v1/' + currentToken + '/rel/topics/' + eventcollectionname;


										let headers = {
											"Content-Type": "application/json",
											"Authorization": "key=" + xAPIkey,
										};
										axios
											.post(
												apiUrl,
												false,
												{
													headers: headers,
												}
											)
											.then((response) => {
												console.log("response==", response);
												alert("You are subscribed to the notification.");
											})
											.catch((error) => {
												console.log(error);
											});
										//-------------------------------------------------------------------------------------
									})
									.catch(function (error) {
										console.error("Error creating Meeting: ", error);
									});
							}
						}
						else {
							IsSubscribed = false;
							store.commit("GetPopupNotification", IsSubscribed);
						}
					}
					else {
						var docdata = doc.data();
						if (docdata) {
							IsSubscribed = true;
							store.commit("GetPopupNotification", IsSubscribed);
							//---------------------- FCM subscribe---------------------------------------------------
							var xAPIkey = "AAAAG8IFqjo:APA91bFOKr3FfPU-5AvL7MT3iKTVoibWIiCKGGRW03nXEmfqbyKfdgN_13R9sTV44JgXWsAN-tR4YGN-6UNcPn04otBHPoeC6ST3mf57aouf9BAjKlwv-X79cs4QTBEW7jbCbo1hqV4W";
							debugger;
							console.log("currentToken:- " + currentToken);
							var apiUrl = 'https://iid.googleapis.com/iid/v1/' + currentToken + '/rel/topics/' + eventcollectionname;

							let headers = {
								"Content-Type": "application/json",
								"Authorization": "key=" + xAPIkey,
							};
							axios
								.post(
									apiUrl,
									false,
									{
										headers: headers,
									}
								)
								.then((response) => {
									console.log(response);
								})
								.catch((error) => {
									console.log(error);
								});
							//-------------------------------------------------------------------------------------
							var dvce = docdata.Devices;
							var flagExixsts = false;
							for (var i = 0; i < dvce.length; i++) {
								if (dvce[i].DeviceToken == currentToken) {
									dvce[i].IsOptIn = true;
									flagExixsts = true;
									break;
								}
							}
							if (flagExixsts) {
								docRef.update({
									Devices: dvce,
								})
									.then(function () {
									});
							}
							else {
								doc.ref.update({
									Devices: firebase.firestore.FieldValue.arrayUnion(
										docObjdevce
									)
								})
							}
						}
					}
					return IsSubscribed;
				})
				.catch(function (error) {
					console.log("Error saving Meeting:", error);
				});
		}).catch((err) => {
			console.log('An error occurred while retrieving token. ', err);
		});
	}
}